/* Native modal navigation. No third-party dependencies or network requests. */
(() => {
  if (window.xwerksNavigationReady) return;
  window.xwerksNavigationReady = true;

  let activeDialog = null;
  let opener = null;
  let scrollPosition = 0;
  let bodyStyle = null;
  let rootStyle = null;
  let backdropPointer = false;
  const bodyProperties = ['overflow', 'padding-right'];
  const rootProperties = ['overflow', 'overscroll-behavior'];

  function expanded(value) {
    document.querySelectorAll('[data-xw-nav-open]').forEach(button => button.setAttribute('aria-expanded', String(value)));
  }

  function restorePage() {
    if (!bodyStyle) return;
    bodyStyle.forEach(([property, value, priority]) => {
      if (value) document.body.style.setProperty(property, value, priority);
      else document.body.style.removeProperty(property);
    });
    bodyStyle = null;
    rootStyle.forEach(([property, value, priority]) => {
      if (value) document.documentElement.style.setProperty(property, value, priority);
      else document.documentElement.style.removeProperty(property);
    });
    rootStyle = null;
    const behavior = document.documentElement.style.getPropertyValue('scroll-behavior');
    const priority = document.documentElement.style.getPropertyPriority('scroll-behavior');
    document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(0, scrollPosition);
    if (behavior) document.documentElement.style.setProperty('scroll-behavior', behavior, priority);
    else document.documentElement.style.removeProperty('scroll-behavior');
  }

  function finishClose(dialog) {
    if (activeDialog !== dialog) return;
    activeDialog = null;
    expanded(false);
    restorePage();
    if (opener?.isConnected && opener.getClientRects().length) opener.focus({preventScroll: true});
    opener = null;
    document.dispatchEvent(new CustomEvent('nav:closed'));
  }

  function close() {
    if (!activeDialog) return;
    const dialog = activeDialog;
    if (dialog.open) dialog.close();
    finishClose(dialog);
  }

  function open(button) {
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal !== 'function') {
      window.location.assign(dialog.querySelector('.xw-nav__all').href);
      return;
    }
    close();
    opener = button;
    scrollPosition = window.scrollY;
    bodyStyle = bodyProperties.map(property => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
    rootStyle = rootProperties.map(property => [property, document.documentElement.style.getPropertyValue(property), document.documentElement.style.getPropertyPriority(property)]);
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    if (gutter > 0) document.body.style.paddingRight = `${padding + gutter}px`;
    activeDialog = dialog;
    dialog.addEventListener('close', () => {if (!dialog.open) finishClose(dialog);}, {once: true});
    dialog.showModal();
    dialog.querySelector('.xw-nav__scroll').scrollTop = 0;
    expanded(true);
    document.dispatchEvent(new CustomEvent('nav:opened'));
  }

  function outsideDialog(event) {
    if (!activeDialog || event.target !== activeDialog) return false;
    const rect = activeDialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  }

  document.addEventListener('pointerdown', event => {backdropPointer = outsideDialog(event);});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-xw-nav-open]');
    if (button) {event.preventDefault();open(button);return;}
    if (event.target.closest('[data-xw-nav-close]') || (backdropPointer && outsideDialog(event))) close();
    backdropPointer = false;
    // Close before following a link so browser back/forward restores a usable page.
    if (activeDialog && event.target.closest('[data-xw-nav] a[href]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) close();
  });
  document.addEventListener('submit', event => {if (event.target.closest('[data-xw-nav]')) close();});
  document.addEventListener('shopify:section:unload', event => {
    if (activeDialog && event.target.contains(activeDialog)) close();
  });
  window.addEventListener('pagehide', close);
})();
